import Component from '@glimmer/component';

export default class MwGrid extends Component {
}
